import React, { FC, useContext } from 'react'
import { ScreenContext } from 'react-components'
import { ListingSectionObject } from '../../../transports/common/listing-section-transport'
import ObjectOverviewCard from '../../common/object-overview-card'
import GridCard from '../../common/grid-card'
import { SuitablesModel } from '../../../models/common/suitables-model'
import { cardEventCategories, pageTypeEventCategories } from '../../../services/analytics-service/categories'
import { BreadcrumbListTransport } from '../../../models/common/breadcrumb-model'
import { Offer } from '../../../models/common/offers-model'

interface ListingItemProps {
    listingObject: ListingSectionObject
    index: number
    requestUrl: string
    breadcrumbModel: BreadcrumbListTransport
    offerModel: Offer
    suitablesModel: SuitablesModel
}

const ListingItem: FC<ListingItemProps> = ({
    listingObject,
    index,
    requestUrl,
    breadcrumbModel,
    offerModel,
    suitablesModel,
}) => {
    const { isMobile } = useContext(ScreenContext)

    if (isMobile) {
        return (
            <GridCard
                key={listingObject.id}
                index={index}
                listingObject={listingObject}
                displayPrice
                displayPriceInfo
                requestUrl={requestUrl}
                showCtaButton
                isObjectOverview
                pageName={pageTypeEventCategories.OBJECT_OVERVIEW_PAGE}
                sectionName={cardEventCategories.sections.LISTINGS}
                showMaxPersonCount
                breadcrumbModel={breadcrumbModel}
                offerModel={offerModel}
                suitablesModel={suitablesModel}
            />
        )
    }

    return (
        <ObjectOverviewCard
            index={index}
            pageName={pageTypeEventCategories.OBJECT_OVERVIEW_PAGE}
            sectionName={cardEventCategories.sections.LISTINGS}
            showBreadcrumbsSection
            key={listingObject.id}
            listingObject={listingObject}
            showMaxPersonCount
            showRegion={false}
            breadcrumbModel={breadcrumbModel}
            offerModel={offerModel}
            suitablesModel={suitablesModel}
        />
    )
}

export default ListingItem
